<template>
  <div class="email-type-input">
    <div class="form-group row">
      <label :class="options.fullWidth ? 'col-sm-12' : 'col-sm-4 col-form-label'">{{ options.label }}</label>
      <input name="name" type="hidden" value="" ref="nameInput"/>
      <div :class="options.fullWidth ? 'col-sm-12' : 'col-sm-8'">
        <select class="form-control" ref="selectInput"
          :name="options.name"
          :value="value"
          @input="changeType($event.target.value)">
          <option value="accountActive">Account Active</option>
          <option value="accountDeactivated">Account Deactivated</option>
          <option value="accountInactive">Account Inactive</option>
          <option value="accountReactivated">Account Reactivated</option>
          <option value="accountRestricted">Account Restricted</option>
          <option value="accountUnrestricted">Account Unrestricted</option>
          <option value="applicationApproved">Application Approved</option>
          <option value="applicationDeclined">Application Declined</option>
          <option value="applicationLink">Send Application Link</option>
          <option value="applicationReminderDay">Application Reminder</option>
          <option value="applicationReminderWeek">Application Week Reminder</option>
          <option value="cardCharged">Account Fee Charged From Card</option>
          <option value="creditCardExpired">Credit Card Expired</option>
          <option value="creditCardExpiring">Credit Card Expiring</option>
          <option value="creditsCharged">Account Fee Charged from Credits</option>
          <option value="deactivateConfirmation">Deactivate Account Request</option>
          <option value="forgotPassword">Forgot Password</option>
          <option value="guarantorForm">Guarantor Form</option>
          <option value="inviteDriver">Invite Driver</option>
          <option value="licenseExpired">Drivers License Expired</option>
          <option value="licenseExpiring">Drivers License Expiring</option>
          <option value="membershipCharge">Scheduled Membership Charge</option>
          <option value="monthlyInvoice">Monthly Invoice</option>
          <option value="reportConfirmation">Report Confirmation</option>
          <option value="resendReservation">Resend Confirmation</option>
          <option value="reservationCancelled">Reservation Cancelled</option>
          <option value="reservationConfirmation">Reservation Confirmation</option>
          <option value="returnedAlarm">Car Not Returned</option>
          <option value="reservationModification">Reservation Modification</option>
        </select>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EmailTypeInput',
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          value: 'sign-up',
          valid: false,
          dirty: false
        }
      }
    }
  },
  mounted () {
    this.changeType()
  },
  methods: {
    changeType (val) {
      let options = this.$refs.selectInput.options
      for (let i = 0; i < options.length; i++) {
        if (options[i].value === this.options.value) {
          this.$refs.nameInput.value = options[i].text
        }
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/EmailTypeInput.vue